import { useNavigate, useSearchParams } from "react-router-dom";
import { signInWithCustomToken, signOut } from "firebase/auth";
import { parseJwt } from "../api";
import NotFoundPage from "../Pages/NotFound/NotFoundPage";
import { useAppDispatch } from "../store";
import { login, refreshToken } from "../store/Auth/authStore";
import { auth } from "../hooks/useAuth";
import React from "react";

export const SuperAdminAuth = () => {
  const [query] = useSearchParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [notFound, setNotFound] = React.useState(false);

  React.useEffect(() => {
    const customToken = query.get("customToken");
    // Preferred: sign in with the Firebase custom token so a REAL, persisted session is
    // created (default browserLocalPersistence). onAuthStateChanged then re-hydrates
    // token+profile on every reload → impersonation survives a page refresh.
    // Signing in replaces whoever is signed in now (the super admin may already be in another
    // customer's account). A full reload then starts the app clean: navigating inside the SPA
    // would keep the previous organization's data in the store.
    if (customToken) {
      signInWithCustomToken(auth, customToken)
        .then(() => window.location.replace("/"))
        .catch(() => setNotFound(true));
      return;
    }

    // Legacy fallback (kept for backend/frontend deploy skew): stuff the pre-exchanged
    // idToken into the store. NOTE: this path does NOT create a Firebase session, so it
    // does not survive a refresh — only used when the backend didn't send a customToken.
    const queryToken = query.get("idToken");
    const data = queryToken ? parseJwt(queryToken) : undefined;
    if (data && data.email && data.user_id && queryToken) {
      // A Firebase session of another account would win again on the next auth event.
      if (auth.currentUser) signOut(auth).catch(() => undefined);
      dispatch(refreshToken(queryToken));
      dispatch(login({ email: data.email, uid: data.user_id }));
      navigate("/");
    } else {
      setNotFound(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return notFound ? <NotFoundPage /> : <div />;
};

/**
 * `/auth` for a signed-in admin: a "Login as Customer" link (it carries a token) switches to that
 * customer; a bare `/auth` just goes home, as before.
 */
export const SignedInAuthRedirect = () => {
  const [query] = useSearchParams();
  return query.get("customToken") || query.get("idToken") ? <SuperAdminAuth /> : <TestTimerRedirect />;
};

export const TestTimerRedirect = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 100);

    // Очистка таймера при размонтировании компонента
    return () => clearTimeout(timer);
  }, [navigate]);

  return <div>Вы будете перенаправлены на главную...</div>;
};
